var iWishCnt = 0,
    iWishlistmain = {},
    iWishsync = !1,
    iWishUrl = "https://iwish.myshopapps.com/ajax/";
if (void 0 === iwishWrapperClass) var iwishWrapperClass = "form";
if (void 0 === iWishVarSelector) var iWishVarSelector = "[name=id]";
if (void 0 === iWishQtySelector) var iWishQtySelector = "[name=quantity]";
if (void 0 === iWishSelectClass) var iWishSelectClass = "#product-select, .single-option-selector, .single-option-selector__radio, select[id|='product-select'], select[id|='product-variants-option'], select[id|='variant-listbox-option']";

function iWishPost(i, s) {
    method = "post";
    var t = document.createElement("form");
    for (var e in t.setAttribute("method", method), t.setAttribute("action", i), s)
        if (s.hasOwnProperty(e)) {
            var n = document.createElement("input");
            n.setAttribute("type", "hidden"), n.setAttribute("name", e), n.setAttribute("value", s[e]), t.appendChild(n)
        } document.head.appendChild(t), t.submit()
}

function getSession() {
    "undefined" != typeof Storage && ("" == iwish_cid && "true" == localStorage.iWishsync && (localStorage.removeItem("iWishlistmain"), localStorage.removeItem("iWishCnt"), localStorage.removeItem("iWishsync")), localStorage.iWishlistmain && (iWishlistmain = JSON.parse(localStorage.getItem("iWishlistmain"))), localStorage.iWishCnt && !isNaN(localStorage.iWishCnt) && (iWishCnt = parseInt(localStorage.iWishCnt)), localStorage.iWishsync && parseInt(iwish_cid) > 0 && "true" == localStorage.iWishsync && (iWishsync = !0), localStorage.setItem("iWishsync", iWishsync))
}

function pushToSession() {
    "undefined" != typeof Storage && ("undefined" !== iWishlistmain && localStorage.setItem("iWishlistmain", JSON.stringify(iWishlistmain)), "undefined" !== iWishCnt && localStorage.setItem("iWishCnt", iWishCnt))
}

function isInWishlist(i, s) {
    return void 0 !== iWishlistmain[i] && null != s && iWishlistmain[i].indexOf(s) >= 0
}

function syncWithServer() {
    var i = JSON.stringify(iWishlistmain);
    jQuery.ajax({
        url: iWishUrl + "syncWishlist.php",
        data: {
            shop: iwish_shop,
            cId: iwish_cid,
            iwishlist: i
        },
        dataType: "jsonp",
        jsonpCallback: "iWishSyncCallback",
        success: function(i) {
            console.log(JSON.stringify(i)), jQuery.extend(iWishlistmain, i.jsonDt), iWishCnt = i.iwishCnt, pushToSession(), jQuery(".iWishCount").html(iWishCnt), console.log("iWishsync done :: " + JSON.stringify(iWishlistmain)), iWishsync = !0, localStorage.setItem("iWishsync", iWishsync), "undefined" != typeof iWishsyncFn && "function" == typeof iWishsyncFn && iWishsyncFn()
        },
        error: function(i, s, t) {}
    })
}

function checkIwish(i, s) {
    var t = i.find(".iWishAdd"),
        e = t.attr("data-product"),
        n = isInWishlist(e, s);
    console.log("checkIwish " + e + " :: " + s), n ? (t.addClass("iwishAdded"), t.not("[data-category]").html(iwish_added_txt)) : (t.removeClass("iwishAdded"), t.not("[data-category]").html(iwish_add_txt)), "undefined" != typeof iWishSelectChangeFn && "function" == typeof iWishSelectChangeFn && iWishSelectChangeFn(i, s)
}

function iwish_addOnly(i, s, t, e, n) {
    if (void 0 === iWishlistmain[i] && (iWishlistmain[i] = []), console.log("Adding " + i + " :: " + s), 0 > iWishlistmain[i].indexOf(s) && (iWishlistmain[i].push(s), iWishCnt++, pushToSession(), jQuery(".iWishCount").html(iWishCnt), parseInt(iwish_cid) > 0)) {
        var a = 1;
        e.parents(iwishWrapperClass).find(iWishQtySelector).length > 0 && (a = e.parents(iwishWrapperClass).find(iWishQtySelector).val()), jQuery.ajax({
            url: iWishUrl + "iwishAdd.php",
            data: {
                shop: iwish_shop,
                cId: iwish_cid,
                pId: i,
                vId: s,
                pTitle: t,
                qty: a,
                catId: n
            },
            dataType: "jsonp",
            jsonpCallback: "iWishAddCallback",
            success: function(t) {
                console.log("iwish_add :: cId: " + iwish_cid + " pId: " + i + " vId: " + s)
            },
            error: function(i, s, t) {
                console.log("iwish_add errorThrown: " + t)
            }
        })
    }
}

function iwish_add(i, s) {
    var t = i.parents(iwishWrapperClass).find(".iWishAdd"),
        e = i.attr("data-product");
    if (null == s || null == e) return !1;
    var n = i.attr("data-pTitle"),
        a = 0;
    if (void 0 !== i.attr("data-category") && "" != i.attr("data-category") && (a = i.attr("data-category")), isInWishlist(e, s)) iwish_remove(i, s, !1), 0 == a && i.not("[data-category]").html(iwish_add_txt);
    else if (iwish_addOnly(e, s, n, i, a), iWishlistmain[e].indexOf(s) >= 0 && (t.addClass("iwishAdded"), 0 == a && t.not("[data-category]").html(iwish_added_txt), "" == iwish_cid)) {
        var h = i.parents(iwishWrapperClass);
        h.find(".iWishLoginMsg").fadeIn(500), setTimeout(function() {
            h.find(".iWishLoginMsg").fadeOut()
        }, 6e3)
    }
    "undefined" != typeof iWishAddFn && "function" == typeof iWishAddFn && iWishAddFn(i, s)
}

function iwish_addCollection(i, s) {
    var t = i.attr("data-product");
    if (null == s || null == t) return !1;
    isInWishlist(t, s) ? (iwish_remove(i, s, !1), i.html(iwish_add_txt_col)) : (iwish_addOnly(t, s, i.attr("data-pTitle"), i, 0), iWishlistmain[t].indexOf(s) >= 0 && i.addClass("iwishAdded").html(iwish_added_txt_col)), "undefined" != typeof iWishaddCollFn && "function" == typeof iWishaddCollFn && iWishaddCollFn()
}

function iwish_remove(i, s, t) {
    var e = !1;
    if (void 0 === iWishlistmain[pId = i.attr("data-product")]) return e;
    console.log("iwish remove :: " + s);
    console.log(s);
    let products = document.querySelectorAll('.s_wishlist .product');
    if (products.length) {
      products.forEach((e)=>{
        let variant_id = e.querySelector('.product__image a').getAttribute('href').split('variant=')[1];
        if (variant_id == s) {
          e.remove();
          setTimeout(()=>{window.wishlist.update();}, 100);
        }
      });
    }
    var n = iWishlistmain[pId].indexOf(s);
    if (n >= 0) {
        iWishlistmain[pId].splice(n, 1), 0 == Object.keys(iWishlistmain[pId]).length && delete iWishlistmain[pId], iWishCnt > 0 && iWishCnt--, jQuery(".iWishCount").html(iWishCnt), pushToSession();
        var t = t || !1;
        !1 == t && (i.removeClass("iwishAdded"), i.parents(iwishWrapperClass).find(".iWishAdd").removeClass("iwishAdded")), parseInt(iwish_cid) > 0 && jQuery.ajax({
            url: iWishUrl + "iwishRemove.php",
            data: {
                shop: iwish_shop,
                cId: iwish_cid,
                pId: pId,
                vId: s
            },
            dataType: "jsonp",
            jsonpCallback: "iWishRemoveCallback",
            success: function(i) {},
            error: function(i, s, t) {}
        }), e = !0
    }
    return "undefined" != typeof iWishRemoveFn && "function" == typeof iWishRemoveFn && iWishRemoveFn(i, s, t), e
}

function iwish_initQV() {
    setTimeout(function() {
      console.log(323);
        if (jQuery(iwish_qvWrapper + ":visible").find(".iWishAdd").length > 0) {
            var i = jQuery(iwish_qvWrapper + ":visible").find(iWishVarSelector).val();
            "" != i && checkIwish(jQuery(iwish_qvWrapper + ":visible").find(iwishWrapperClass), i), "undefined" != typeof iWishQvFn && "function" == typeof iWishQvFn && iWishQvFn()
        } else iwish_initQV()
    }, 300)
}

function iwish_updateQty(i, s) {
    jQuery.ajax({
        url: iWishUrl + "iwishUpdateQty.php",
        data: {
            shop: iwish_shop,
            cId: iwish_cid,
            iwishpQty: s,
            vId: i
        },
        dataType: "jsonp",
        jsonpCallback: "iWishUpdateQtyCallback",
        success: function(i) {},
        error: function(i, s, t) {}
    }), "undefined" != typeof iwishUpdateQtyFn && "function" == typeof iwishUpdateQtyFn && iwishUpdateQtyFn()
}

function iwishCheckColl() {
    jQuery(".iwishcheck").length > 0 && jQuery(".iwishcheck").each(function() {
        var i = jQuery(this).attr("data-variant");
        isInWishlist(jQuery(this).attr("data-product"), i) ? jQuery(this).addClass("iwishAdded").html(iwish_added_txt_col) : jQuery(this).removeClass("iwishAdded").html(iwish_add_txt_col), jQuery(this).removeClass("iwishcheck")
    })
}

function iwishInit() {
    var i = !!jQuery.fn.on;
    if (iwish_pro_template) {
        var s = jQuery(".iWishAdd:visible").parents(iwishWrapperClass),
            t = s.find(iWishVarSelector).val();
        "" != t && checkIwish(s, t)
    }
    jQuery(".iWishCount").html(iWishCnt), parseInt(iwish_cid) > 0 && !iWishsync && (console.log("Sync Need to be done"), syncWithServer()), "undefined" != typeof iwish_qvButton && "undefined" != typeof iwish_qvWrapper && (i ? jQuery("body").on("click", iwish_qvButton, function() {
        iwish_initQV()
    }) : jQuery("body").delegate(iwish_qvButton, "click", function() {
        iwish_initQV()
    })), i ? jQuery(document).on("change", iWishSelectClass, function() {
        selectedClass = jQuery(this).parents(iwishWrapperClass), setTimeout(function() {
            var i = selectedClass.find(iWishVarSelector).val();
            "" != i ? checkIwish(selectedClass, i) : (selectedClass.find(".iWishAdd").removeClass("iwishAdded"), selectedClass.find(".iWishAdd").not("[data-category]").html(iwish_add_txt))
        }, 400)
    }) : jQuery(document).delegate(iWishSelectClass, "change", function() {
        selectedClass = jQuery(this).parents(iwishWrapperClass), setTimeout(function() {
            var i = selectedClass.find(iWishVarSelector).val();
            "" != i ? checkIwish(selectedClass, i) : (selectedClass.find(".iWishAdd").removeClass("iwishAdded"), selectedClass.find(".iWishAdd").not("[data-category]").html(iwish_add_txt))
        }, 400)
    }), "undefined" != typeof iWishinitFn && "function" == typeof iWishinitFn && iWishinitFn(), jQuery(".iwishRemoveBtn").click(function() {
        if (jQuery(this).hasClass("iwishRemoved")) return !1;
        var i = jQuery(this).attr("data-variant");
        return iwish_remove(jQuery(this), i, !0) && (jQuery(this).addClass("iwishRemoved"), jQuery(this).parents(".iwishItem").remove(), jQuery(".iwishMsgSuccess").show(), setTimeout(function() {
            jQuery(".iwishMsgSuccess").fadeOut(), 0 == iWishCnt && jQuery(".iwishMsgInfo").fadeIn()
        }, 3e3)), !1
    }), jQuery("input[name=iwishProQuantity]").change(function() {
        var i = jQuery(this),
            s = parseInt(i.val()),
            t = i.parents(".iwishItem").find(iWishVarSelector).val();
        parseInt(iwish_cid) > 0 && (s > 0 ? (iwish_updateQty(t, s), i.parents(".iwishItem").find("[name=quantity]").val(s), i.addClass("iwishProQtyAdded"), setTimeout(function() {
            i.removeClass("iwishProQtyAdded")
        }, 2e3), i.parents(".iwishItem").find(".iwishQtyMsg").fadeIn().delay(3e3).fadeOut()) : (i.val(1).addClass("iwishProQtyError"), setTimeout(function() {
            i.removeClass("iwishProQtyError")
        }, 1e3)))
    })
}
getSession(), iwishInit(), iwishCheckColl();


let wishlist_email_form = document.querySelector('html[lang="pl"] .iwishEmailWishlist');
if (wishlist_email_form) {
  document.querySelector('.iwishEmailWishlist').innerHTML += '<div class="loading-state"></div>';
}


window.onload = function () {
  let wishlist_email_form = document.querySelector('html[lang="pl"] .iwishEmailWishlist');
  if (wishlist_email_form) {
    
    let back_btn = document.querySelector('.iwishEmailWishlist .iwishTitle + div a');
    if (back_btn) {
      back_btn.innerHTML = '&laquo; Powrót do listy ulubionych';
    }
    
    let p_items = document.querySelectorAll('.iwishEmailWishlist #mailToForm p');
    if (p_items.length) {
      p_items.forEach((e, index) => {
        if (index == 0) {
          e.querySelector('label').innerHTML = 'Adres e-mail odbiorcy';
          e.querySelector('input').setAttribute('placeholder', '');
        }
        if (index == 1) {
          e.querySelector('label').innerHTML = 'Twoje imię';
          e.querySelector('input').setAttribute('placeholder', '');
        }
        if (index == 2) {
          e.querySelector('label').innerHTML = 'Twój adres e-mail';
          e.querySelector('input').setAttribute('placeholder', '');
        }
        if (index == 3) {
          e.querySelector('label').innerHTML = 'Temat wiadomości';
          e.querySelector('input').setAttribute('placeholder', '');
        }
        if (index == 4) {
          e.querySelector('label').innerHTML = 'Krótki opis';
        }
        if (index == 5) {
          e.querySelector('label').innerHTML = 'Adres Twojej wishlisty';
        }
      });
    }

    let submit_btn = document.querySelector('.iwishEmailWishlist #mailToForm .btn');
    if (submit_btn) {
      submit_btn.innerHTML = 'Wyślij listę'
    }

    let message_success = document.querySelector('.iwishEmailWishlist .iwishMsgSuccess');
    if (message_success) {
      message_success.innerHTML = 'Twoja lista została wysłana'
    }
  }


  let wishlist = document.querySelector('.iwishEmailWishlist');
  if (wishlist) {
    wishlist.classList.add('init');
  }
}
